export class JoinTextRelationalItem {
  constructor(
    public itemType: string,
    public objectId: string,
    public key: string,
    public value: string,
  ) {
  }
}
